export default "__VITE_ASSET__ClLakEZm__"